// This function enables toggling the ADA chat overlay on and off.

// eslint-disable-next-line no-unused-vars
function toggleOverlayButtons() {
  const adaChatFrame = document.getElementById('ada-button-frame');
  const discountButton = document.querySelector('.discount-button');
  if (adaChatFrame) {
    adaChatFrame.classList.toggle('hidden');
  }
  if (discountButton) {
    discountButton.classList.toggle('hidden');
  }
}
